// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".\\+GaG{display:inline}.Ag-s{align-items:center;color:var(--main-blue);cursor:pointer;display:inline-flex;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ekRr{--s:24px;height:24px;width:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionSidebarSettingsQuery": "+GaG",
	"actionSidebarSettingsQueryText": "Ag-s",
	"actionSidebarSettingsQueryIcon": "ekRr"
};
module.exports = ___CSS_LOADER_EXPORT___;
